import { TableHeaderColumnItem } from "../components/table/TableHeaderColumnItem";

export const authorizedUsersTableColumns: TableHeaderColumnItem[] = [
    {
        columnName: 'User',
        sortParam: 'user.username'
    },
    {
        columnName: 'Customer number',
        sortParam: 'customer.customerNumber'
    },
    {
        columnName: "Customer name",
        sortParam: 'customer.name'
    },
    {
        columnName: 'Period of validity',
        sortParam: 'startDate'
    },
    {
        columnName: 'Renew automatically',
        sortParam: ''
    },
    /*Last column for delete*/
    {
        columnName: '',
        sortParam: ''
    },
];

export const customerAuthorizationsTableColumns: TableHeaderColumnItem[] = [
    {
        columnName: 'Customer number',
        sortParam: 'customer.customerNumber'
    },
    {
        columnName:"Customer name",
        sortParam: 'customer.name'
    },
    {
        columnName: 'Period of validity',
        sortParam: 'startDate'
    },
    {
        columnName: 'Relation',
        sortParam: 'relation'
    },
    /*Last column for delete*/
    {
        columnName: '',
        sortParam: ''
    },
];

export const sentApplicationsTableColumns: TableHeaderColumnItem[] = [
    {
        columnName: 'Customer number',
        sortParam: 'requesteeCustomerNumber'
    },
    {
        columnName: 'Receiver username',
        sortParam: 'requesteeUsername'
    },
    {
        columnName: 'Period of validity',
        sortParam: 'startDate'
    },
    {
        columnName: 'Created',
        sortParam: 'created'
    },
    {
        columnName: 'Status',
        sortParam: 'status'
    },
];

export const receivedApplicationsTableColumns: TableHeaderColumnItem[] = [
    {
        columnName: 'Customer number',
        sortParam: 'requesteeCustomerNumber'
    },
    {
        columnName: 'Applicant username',
        sortParam: 'requestorUser.username'
    },
    {
        columnName: 'Applicant name',
        sortParam: 'requestorUser.lastName'
    },
    {
        columnName: 'Period of validity',
        sortParam: 'startDate'
    },
    {
        columnName: 'Status',
        sortParam: 'status'
    },
];

export const organizationTableColumns: TableHeaderColumnItem[] = [
    {
        columnName: 'Organization name',
        sortParam: 'name'
    },
    {
        columnName: 'Description',
        sortParam: 'description'
    }
];